/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Account } from "App/IOC/Services";

export default {
    GetInvitation: Account.GetInvitation,
    Activate: Account.Activate,
    Login: Account.Login,
    ConfirmTotp: Account.ConfirmTotp,
    ForgotPassword: Account.ForgotPassword,
    GetResetToken: Account.GetResetToken,
    ResetPassword: Account.ResetPassword
};
